<script>
import { iButton, iTextInput, showToast } from '@inscribe/signal';
import { isValidEmail } from '@/utils/validation';
import { LOCAL_STORAGE_REDIRECT_URL } from '@/constants/login';
import { encodeQueryParams } from '@/utils/queryParams';

export default {
  components: { iButton, iTextInput },
  data() {
    return {
      email: '',
      loading: false,
      displayHint: false,
    };
  },
  computed: {
    isValidEmail() {
      return isValidEmail(this.email);
    },
    signInLink() {
      let baseUrl = '/auth/login';
      if (this.$route.query) {
        baseUrl = `${baseUrl}?${encodeQueryParams(this.$route.query)}`;
      }
      return baseUrl;
    },
  },
  mounted() {
    if (this.$route.query.redirectUrl) {
      localStorage.setItem(
        LOCAL_STORAGE_REDIRECT_URL,
        this.$route.query.redirectUrl,
      );
    }
  },
  methods: {
    tryLogin(e) {
      this.displayHint = false;
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (this.isValidEmail) {
        const data = new FormData();
        data.append('email', this.email);
        this.loading = true;
        this.$store
          .dispatch('samlLogin', data)
          .then((response) => {
            this.loading = false;
            setTimeout(() => {
              window.location.href = response.data.idp_url;
            }, 250);
          })
          .catch((error) => {
            this.loading = false;
            showToast({
              title: 'Error logging in',
              text: error?.response?.data?.message || 'Please try again later',
              isError: true,
            });
          });
      } else {
        this.displayHint = true;
      }
    },
  },
};
</script>

<template>
  <div
    class="login-screen auth-screen d-flex flex-column align-items-center justify-content-center i-gap-10"
  >
    <!-- title -->
    <div class="title d-flex flex-column align-items-center i-gap-1">
      <div class="i-text-heading-3 i-text-neutral-120">Single Sign-On</div>
      <div class="i-text-body-1 i-text-neutral-110">
        Enter your email address below
      </div>
    </div>

    <!-- form -->
    <div class="form d-flex flex-column i-gap-10">
      <i-text-input
        label="SSO Email"
        :value="email"
        placeholder="Enter your email"
        name="email"
        type="email"
        :has-error="displayHint && !isValidEmail"
        :show-hint-text="displayHint && !isValidEmail"
        hint-text="Valid email required"
        @input="email = $event"
        @on-input-enter="tryLogin"
      >
      </i-text-input>

      <!-- login button -->
      <i-button
        text="Sign In"
        type="primary"
        subtype="strong"
        size="lg"
        :loading="loading"
        @button-click="tryLogin"
      ></i-button>

      <!-- link standard login -->
      <div class="login-link d-flex justify-content-center">
        <router-link class="i-text-subheading-2" :to="signInLink">
          Back to Sign In
        </router-link>
      </div>

      <!-- account creation -->
      <div
        class="account-creation d-flex flex-column justify-content-start align-items-center i-radius-lg i-px-8 i-py-6"
      >
        <div class="i-text-body-3 i-text-neutral-110">
          Don't have an account?
        </div>
        <a
          class="i-text-subheading-3"
          target="_blank"
          href="https://www.inscribe.ai/demo-request"
          >Contact Sales</a
        >
      </div>
    </div>
  </div>
</template>
